var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-redirect",class:[
    { 'button-redirect_reverse': _vm.arrowPosition === 'right' },
    `button-redirect_${_vm.buttonStyle}`,
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"button-redirect__icon",class:`icon-${_vm.icon}`}),_c('span',{staticClass:"button-redirect__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }